import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { dangNhapGoogle, theoDoiDangNhap } from "../lib/auth.js";
import { layDb } from "../lib/firebase.js";
import { VIDEOS_CODE } from "../data/videos.js";
import { chuanHoaVideo, tachMaYoutube, anhBia, thoiLuongChu } from "@shared/video.js";
import { docTatCaVideo, luuVideo, xoaVideo, layTieuDeYoutube } from "../lib/videos.js";
import { cacTrangGanDuoc, tenTrang } from "../lib/videoTrang.js";

/**
 * /admin/video: thêm video YouTube Shorts và gắn vào trang trên site.
 * Lưu xong, video lên site ở lần build kế tiếp (GitHub Action chạy mỗi 2 giờ,
 * hoặc khi deploy). Video trong src/data/videos.js hiện ở đây để tham khảo;
 * lưu một video như thế sẽ tạo bản trên Firestore thay cho bản trong code.
 */
const TRONG = chuanHoaVideo({});

function useQuyenQuanTri() {
  const [s, setS] = useState({ user: null, role: "", checking: true });
  useEffect(() => theoDoiDangNhap(async (next) => {
    setS({ user: next, role: "", checking: true });
    let role = "";
    if (next) try {
      const db = await layDb();
      const { doc, getDoc } = await import("firebase/firestore/lite");
      const snap = await getDoc(doc(db, "admins", next.uid));
      role = snap.exists() ? snap.data()?.role || "" : "";
    } catch { role = ""; }
    setS({ user: next, role, checking: false });
  }), []);
  return { ...s, allowed: ["admin", "editor"].includes(s.role) };
}

export default function VideoAdmin() {
  const { user, allowed, checking } = useQuyenQuanTri();
  const [list, setList] = useState([]);
  const [d, setD] = useState({ ...TRONG, link: "", ganVaoChu: "" });
  const [msg, setMsg] = useState("");
  const [ban, setBan] = useState(false);
  const [timTrang, setTimTrang] = useState("");
  const tatCaTrang = useMemo(() => cacTrangGanDuoc(), []);

  async function taiLai() {
    try { setList(await docTatCaVideo()); } catch (e) { setMsg(e.message); }
  }
  useEffect(() => { if (allowed) taiLai(); }, [allowed]);

  const tuCode = VIDEOS_CODE.map((v) => chuanHoaVideo(v)).filter((v) => v.id && !list.some((x) => x.id === v.id));
  const set = (k, v) => setD((o) => ({ ...o, [k]: v }));
  const id = tachMaYoutube(d.link);
  const ganVao = d.ganVaoChu.split(/\n+/).map((x) => x.trim()).filter(Boolean);
  const goiY = timTrang.trim().length >= 2
    ? tatCaTrang.filter((t) => t.ten.toLowerCase().includes(timTrang.trim().toLowerCase()) && !ganVao.includes(t.path)).slice(0, 8)
    : [];

  function mo(v) {
    setD({ ...v, link: `https://youtube.com/shorts/${v.id}`, ganVaoChu: v.ganVao.join("\n") });
    setMsg(""); window.scrollTo({ top: 0, behavior: "smooth" });
  }
  async function dienTuYoutube() {
    if (!id) { setMsg("Link chưa đúng dạng YouTube."); return; }
    const t = await layTieuDeYoutube(id);
    if (t) set("tieuDe", t); else setMsg("Không lấy được tiêu đề từ YouTube, bạn gõ tay nhé.");
  }
  async function luu(status) {
    setBan(true); setMsg("");
    try {
      await luuVideo({ ...d, id, ganVao }, status);
      setMsg(status === "PUBLISHED" ? "Đã lưu và xuất bản. Video lên site ở lần build kế tiếp (tối đa khoảng 2 giờ)." : "Đã lưu nháp.");
      await taiLai();
    } catch (e) { setMsg(e?.code === "permission-denied" ? "Tài khoản này chưa có quyền (hoặc chưa deploy firestore.rules có mục videos)." : e.message); }
    finally { setBan(false); }
  }
  async function xoa() {
    if (!window.confirm("Xoá video này khỏi site? Video trên YouTube không bị ảnh hưởng.")) return;
    setBan(true);
    try { await xoaVideo(id); setD({ ...TRONG, link: "", ganVaoChu: "" }); setMsg("Đã xoá."); await taiLai(); }
    catch (e) { setMsg(e.message); } finally { setBan(false); }
  }

  if (checking) return <p>Đang kiểm tra quyền…</p>;
  if (!user) return <section className="surface"><h1>Quản trị video</h1><button type="button" className="nut" onClick={() => dangNhapGoogle()}>Đăng nhập Google</button></section>;
  if (!allowed) return <section className="surface"><h1>Quản trị video</h1><p>Tài khoản {user.email} chưa có quyền quản trị nội dung.</p></section>;

  const daCo = list.some((x) => x.id === id);
  return (
    <div className="vn-admin">
      <h1>Video ngắn</h1>
      <p className="nho">Dán link YouTube Shorts, gắn vào trang mà video giải thích. Trang đó sẽ hiện khối "Xem nhanh" và khai video cho Google. Xem kết quả ở <Link to="/video">/video</Link>.</p>

      <section className="surface story-form vn-admin-form">
        <h2>{daCo ? "Sửa video" : "Thêm video"}</h2>
        <div className="vn-admin-hang">
          <div>
            <label htmlFor="va-link">Link YouTube</label>
            <input id="va-link" type="text" value={d.link} placeholder="https://youtube.com/shorts/..." onChange={(e) => set("link", e.target.value)} />
            {d.link && !id && <p className="story-loi">Không đọc được mã video từ link này.</p>}
          </div>
          {id && <img className="vn-admin-anh" src={anhBia(id)} alt="" width="120" height="90" />}
        </div>
        <label htmlFor="va-td">Tiêu đề hiển thị</label>
        <div className="hang-nut">
          <input id="va-td" type="text" value={d.tieuDe} maxLength={140} onChange={(e) => set("tieuDe", e.target.value)} style={{ flex: "1 1 16rem" }} />
          <button type="button" className="nut phu" disabled={!id} onClick={dienTuYoutube}>Lấy từ YouTube</button>
        </div>
        <label htmlFor="va-mt">Mô tả ngắn (1 đến 2 câu, Google đọc phần này)</label>
        <textarea id="va-mt" rows="2" maxLength={400} value={d.moTa} onChange={(e) => set("moTa", e.target.value)} />
        <div className="o-nhap">
          <div><label htmlFor="va-ngay">Ngày đăng trên YouTube</label><input id="va-ngay" type="date" value={d.ngayDang} onChange={(e) => set("ngayDang", e.target.value)} /></div>
          <div><label htmlFor="va-tl">Thời lượng (giây)</label><input id="va-tl" type="number" min="1" max="3600" value={d.thoiLuong ?? ""} onChange={(e) => set("thoiLuong", e.target.value)} /></div>
          <div><label htmlFor="va-loat">Loạt video</label><input id="va-loat" type="text" list="va-loat-ds" value={d.loat} placeholder="Từ điển 60 giây" onChange={(e) => set("loat", e.target.value)} />
            <datalist id="va-loat-ds">{[...new Set([...list, ...tuCode].map((v) => v.loat).filter(Boolean))].map((l) => <option key={l} value={l} />)}</datalist></div>
        </div>

        <label htmlFor="va-gan">Gắn vào trang (mỗi dòng một đường dẫn, tối đa 6)</label>
        <textarea id="va-gan" rows="3" value={d.ganVaoChu} placeholder="/thuat-ngu/vesting-la-gi" onChange={(e) => set("ganVaoChu", e.target.value)} />
        {ganVao.length > 0 && <ul className="nho vn-admin-gan">{ganVao.map((p) => <li key={p}>{p}: {tenTrang(p) ? <strong>{tenTrang(p)}</strong> : <span className="story-loi">không có trang này</span>}</li>)}</ul>}
        <label htmlFor="va-tim">Tìm trang để gắn</label>
        <input id="va-tim" type="search" value={timTrang} placeholder="Gõ: vesting, pitch deck, cap table…" onChange={(e) => setTimTrang(e.target.value)} />
        {goiY.length > 0 && <ul className="vn-admin-goi-y">{goiY.map((t) => (
          <li key={t.path}><button type="button" className="text-button" onClick={() => { set("ganVaoChu", [...ganVao, t.path].join("\n")); setTimTrang(""); }}>+ {t.ten}</button></li>
        ))}</ul>}

        <details>
          <summary>Lời thoại (không bắt buộc)</summary>
          <p className="nho">Dán phụ đề của video. Google đọc được chữ, video có thêm cơ hội hiện trong kết quả tìm kiếm.</p>
          <textarea rows="5" maxLength={4000} value={d.loiThoai} onChange={(e) => set("loiThoai", e.target.value)} />
        </details>

        {msg && <p className="nho" role="status">{msg}</p>}
        <div className="hang-nut">
          <button type="button" className="nut" disabled={ban || !id} onClick={() => luu("PUBLISHED")}>Lưu và xuất bản</button>
          <button type="button" className="nut phu" disabled={ban || !id} onClick={() => luu("DRAFT")}>Lưu nháp (ẩn khỏi site)</button>
          <button type="button" className="text-button" onClick={() => { setD({ ...TRONG, link: "", ganVaoChu: "" }); setMsg(""); }}>Video mới</button>
          {daCo && <button type="button" className="text-button danger" disabled={ban} onClick={xoa}>Xoá</button>}
        </div>
      </section>

      <section className="surface">
        <h2>Đã có ({list.length + tuCode.length})</h2>
        <ul className="vn-admin-ds">
          {[...list.map((v) => ({ v, nguon: "" })), ...tuCode.map((v) => ({ v, nguon: "trong code" }))]
            .sort((a, b) => (b.v.ngayDang || "").localeCompare(a.v.ngayDang || ""))
            .map(({ v, nguon }) => (
              <li key={v.id}>
                <button type="button" className="text-button" onClick={() => mo(v)}><strong>{v.tieuDe || v.id}</strong></button>
                <span className="nho"> {v.status === "PUBLISHED" ? "Đã xuất bản" : "Nháp"}{v.ngayDang ? `, ${v.ngayDang.split("-").reverse().join("/")}` : ""}{v.thoiLuong ? `, ${thoiLuongChu(v.thoiLuong)}` : ""}{nguon ? `, ${nguon}` : ""}</span>
                <span className="nho vn-admin-gan-mot">{v.ganVao.length ? v.ganVao.map((p) => tenTrang(p) || p).join("; ") : "Chưa gắn trang nào"}</span>
              </li>
            ))}
        </ul>
      </section>
    </div>
  );
}
